<section class="banner ">
  <div class="container mx-auto ps-4  border-l border-l-gray-300 bg-blur bg-blur-left">
    <div class="grid lg:grid-cols-2 gap-4">
      <div>
        <h1 class="title-heading" data-sal="slide-up" data-sal-duration ='500'>Where Corporate Travel Meets Excellence</h1>
        <p class="text-orange-500 mt-3 font-medium"  data-sal="zoom-in" data-sal-duration ='500' >Access Exclusive Corporate Rates & World-Class Service
        </p>
        <a href=""  data-sal="slide-up" data-sal-duration ='500' class="butn butn-orange mt-6">Get Started <span
          class="ms-3 icon-arrow-right-long"></span></a>
      </div>
      <div class="h-full flex flex-col justify-center relative">
        <ul class="bullet-line">
          <li data-sal="slide-up" data-sal-duration ='500'  data-sal-delay="300"><a href="#managePartner"
                                                                                    class="nav-link-bullet blue hover:text-orange-500 transition font-medium">Travel
            Management Partner</a></li>
          <li data-sal="slide-up" data-sal-duration ='700'  data-sal-delay="500">
            <a href="#travelBookingSolutions"
               class="nav-link-bullet yellow hover:text-orange-500 transition font-medium">Travel
              Booking Solutions</a>
          </li>
          <li data-sal="slide-up" data-sal-duration ='1000'  data-sal-delay="700"><a href="#approachSection"
                                                                                     class="nav-link-bullet red hover:text-orange-500 transition font-medium">Our
            Approach</a></li>
        </ul>
      </div>
    </div>
  </div>
</section>
<section id="managePartner" class="manage-partner">
  <div class="container mx-auto ps-4 border-l border-l-gray-300   section-pad">
    <div class="relative  bg-blur">
      <img src="assets/images/travel-manage-partner.png" data-sal="zoom-in"  data-sal-duration ='500' alt="travel-manage-partner" class="mx-auto desk-img"
           width="555px" height="576px">
      <img src="assets/images/travel-manage-partner-mobile.png" data-sal="zoom-in"  data-sal-duration ='500'  alt="travel-manage-partner"
           class="mx-auto mob-img" width="301px" height="314px">
      <span class="title-circle blue" data-sal="zoom-out" data-sal-duration ='1000' data-sal-delay="500" >
                    <span class="icon-handshake"></span>
                </span>
    </div>
    <div class="section-top-mar">
      <div class="grid lg:grid-cols-2 gap-4">
        <div>
          <span class="title-tag-line" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="500">Welcome To</span>
          <h2 class="title-sub mt-3" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="700">Umbrella Travel Your Trusted Travel Management Partner</h2>
          <p class="font-normal" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="800">Umbrella Travel, we specialize in providing customized travel management
            solutions tailored to the unique needs of businesses and organizations. Whether you're a
            large corporation, an SMME, a government entity, or a production company in the film
            industry, our expertise ensures your travel experience is smooth, efficient, and
            cost-effective.</p>
          <div class="orange-box-wrapper">
            <div data-sal="zoom-in"  data-sal-duration ='500' data-sal-delay="200"
                 class="bg-orange-50 rounded-xl flex flex-col items-center justify-center p-4 hover:bg-orange-100 transition-all">
              <span class="icon-buildings text-4xl text-orange-500"></span>
              <h3 class="title-second-sub mt-2">Corporates</h3>
            </div>
            <div data-sal="zoom-in"  data-sal-duration ='500' data-sal-delay="300"
                 class="bg-orange-50 rounded-xl flex flex-col items-center justify-center p-4 hover:bg-orange-100 transition-all">
              <span class="icon-store text-4xl text-orange-500"></span>
              <h3 class="title-second-sub mt-2">SMMEs</h3>
            </div>
            <div data-sal="zoom-in"  data-sal-duration ='500' data-sal-delay="500"
                 class="bg-orange-50 rounded-xl flex flex-col items-center justify-center p-4 hover:bg-orange-100 transition-all">
              <span class="icon-clapperboard text-4xl text-orange-500"></span>
              <h3 class="title-second-sub mt-2">Film Industry</h3>
            </div>
            <div data-sal="zoom-in"  data-sal-duration ='500' data-sal-delay="700"
                 class="bg-orange-50 rounded-xl flex flex-col items-center justify-center p-4 hover:bg-orange-100 transition-all">
              <span class="icon-bank text-4xl text-orange-500"></span>
              <h3 class="title-second-sub mt-2">Government</h3>
            </div>
          </div>
        </div>
        <div>
          <img src="assets/images/travel-manage-partner-booking.png" alt="travel-manage-partner-booking"
               class="ms-auto desk-img" width="471px" height="582px" loading="lazy" data-sal="zoom-in"  data-sal-duration ='500'>

        </div>
      </div>
    </div>
  </div>
</section>
<section id="travelBookingSolutions" class="travel-booking-solutions ">
  <div class="container mx-auto ps-4 border-l border-l-gray-300   section-pad">
    <div class="relative  bg-blur">
      <img src="assets/images/travel-booking-solutions.png"  data-sal="slide-right"  data-sal-duration ='500'  alt="travel-booking-solutions"
           class="mx-auto desk-img" width="555px" height="563px" loading="lazy">
      <img src="assets/images/travel-booking-solutions-mobile.png" data-sal="slide-right"  data-sal-duration ='500' alt="travel-booking-solutions"
           class="mx-auto mob-img" width="301px" height="305px" loading="lazy">

      <span class="title-circle yellow" data-sal="zoom-out"  data-sal-duration ='1000' data-sal-delay="500">
                    <span class="icon-calendar-clock"></span>
                </span>
    </div>
    <div class="section-top-mar ">
      <div class="grid lg:grid-cols-2 gap-4">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="98.426"
               viewBox="0 0 567.266 98.426">
            <g id="Group_165" data-name="Group 165" transform="translate(-354.311 -3155.357)">
              <path id="Path_283" class="path-way" data-name="Path 283"
                    d="M0,0S13.033-65.149,157.658-65.149C267.8-63.07,310.846,11.252,394.577,22.137,495.746,35.289,545.248-38.132,545.248-38.132"
                    transform="translate(369 3227.5)" fill="none" stroke="#bebebe" stroke-width="2"
                    stroke-dasharray="6 6" />
              <path id="plane"
                    d="M9.416,0a.677.677,0,0,1,.531.308l4.011,7.021H18.32c1.349,0,3.664,1.094,3.664,2.443s-2.315,2.443-3.664,2.443H13.958L9.946,19.235a.611.611,0,0,1-.53.308h-2.5a.611.611,0,0,1-.587-.779L8.2,12.214H4.274l-1.648,2.2a.612.612,0,0,1-.489.245H.61A.61.61,0,0,1,.018,13.9l1.2-4.127L.018,5.644A.61.61,0,0,1,.61,4.886H2.137a.612.612,0,0,1,.489.245l1.648,2.2H8.2L6.329.778A.61.61,0,0,1,6.916,0Z"
                    transform="translate(354.311 3250.054) rotate(-79)" fill="#19bdc2" />
              <path id="location-dot"
                    d="M7.328,0A7.329,7.329,0,0,0,0,7.328c0,2.955,1.029,3.78,6.576,11.82a.916.916,0,0,0,1.505,0c5.546-8.04,6.576-8.865,6.576-11.82A7.329,7.329,0,0,0,7.328,0Zm0,10.382a3.054,3.054,0,1,1,3.053-3.053A3.056,3.056,0,0,1,7.328,10.382Z"
                    transform="translate(606.094 3155.357)" fill="#c81f1f" />
              <path id="location-dot-2" data-name="location-dot"
                    d="M7.328,0A7.329,7.329,0,0,0,0,7.328c0,2.955,1.029,3.78,6.576,11.82a.916.916,0,0,0,1.505,0c5.546-8.04,6.576-8.865,6.576-11.82A7.329,7.329,0,0,0,7.328,0Zm0,10.382a3.054,3.054,0,1,1,3.053-3.053A3.056,3.056,0,0,1,7.328,10.382Z"
                    transform="translate(906.92 3165.128)" fill="#c81f1f" />
            </g>
          </svg>

          <span class="title-tag-line inline-flex mt-5" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="500">Corporate</span>
          <h2 class="title-sub mt-3" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="700">Travel Booking Solutions</h2>
          <p class="font-normal" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="800">Umbrella Travel, we offer seamless and comprehensive travel management
            services for businesses of all sizes. Our corporate travel solutions cover every aspect of
            your journey, from air travel and accommodation to ground transportation. We ensure that
            your travel experience is efficient, cost-effective, and stress-free, allowing you to focus
            on your business.</p>
          <a href="" class="butn butn-orange mt-6" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="1000">Get Going <span
            class="ms-3 icon-arrow-right-long"></span></a>
        </div>
        <div>
          <img src="assets/images/corporate-travel-booking.png" alt="corporate-travel-booking" data-sal="zoom-in"  data-sal-duration ='500'
               class="ms-auto desk-img" width="601px" height="601px" loading="lazy">
          <img src="assets/images/corporate-travel-booking-mobile.png" alt="corporate-travel-booking" data-sal="zoom-in"  data-sal-duration ='500'
               class="mx-auto mob-img" width="301px" height="302px" loading="lazy">
        </div>
      </div>
    </div>
    <div class="section-top-mar section-top-pad">
      <div class="border-b border-gray-200  ">
        <nav class="flex flex-nowrap overflow-x-auto justify-start md:justify-center gap-x-5"
             aria-label="Tabs" role="tablist" aria-orientation="horizontal">
          <button type="button"
                  class="text-start font-medium hs-tab-active:border-orange-500 hs-tab-active:text-orange-500 py-4 px-1 inline-flex items-center gap-x-2 border-b-2 border-transparent whitespace-nowrap text-gray-500 hover:text-orange-500 focus:outline-none focus:text-orange-500 disabled:opacity-50 disabled:pointer-events-none  active"
                  id="tabs-with-icons-item-1" aria-selected="true" data-hs-tab="#tabs-with-icons-1"
                  aria-controls="tabs-with-icons-1" role="tab">
            <span class="icon-plane text-4xl "></span>
            <span class="ms-2">Air Travel</span>
          </button>
          <button type="button"
                  class="text-start font-medium hs-tab-active:border-orange-500 hs-tab-active:text-orange-500 py-4 px-1 inline-flex items-center gap-x-2 border-b-2 border-transparent whitespace-nowrap text-gray-500 hover:text-orange-500 focus:outline-none focus:text-orange-500 disabled:opacity-50 disabled:pointer-events-none "
                  id="tabs-with-icons-item-2" aria-selected="false" data-hs-tab="#tabs-with-icons-2"
                  aria-controls="tabs-with-icons-2" role="tab">
            <span class="icon-hotel text-4xl "></span>
            <span class="ms-2">Accommodation </span>
          </button>
          <button type="button"
                  class="text-start font-medium hs-tab-active:border-orange-500 hs-tab-active:text-orange-500 py-4 px-1 inline-flex items-center gap-x-2 border-b-2 border-transparent whitespace-nowrap text-gray-500 hover:text-orange-500 focus:outline-none focus:text-blue-600 disabled:opacity-50 disabled:pointer-events-none "
                  id="tabs-with-icons-item-3" aria-selected="false" data-hs-tab="#tabs-with-icons-3"
                  aria-controls="tabs-with-icons-3" role="tab">
            <span class="icon-train-subway text-4xl "></span>
            <span class="ms-2">Ground Travel</span>
          </button>
        </nav>
      </div>

      <div class="mt-3">
        <div id="tabs-with-icons-1" role="tabpanel" aria-labelledby="tabs-with-icons-item-1">
          <div class="grid lg:grid-cols-2 gap-4">
            <div class="p-5">
              <span class="title-tag-line inline-flex" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="500">Seamless</span>
              <h2 class="title-second-sub my-3" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="700">Corporate air travel solutions with exclusive rates.
              </h2>
              <p class="" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="800">We understand that air travel is a critical component of corporate travel.
              </p>
            </div>
            <div class="p-5">
              <ul class="space-y-3">
                <li class="flex gap-x-3" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="500">
                  <span class="flex items-center icon-star text-orange-500"></span>
                  <span class="">Access to exclusive corporate rates and discounts.</span>
                </li>

                <li class="flex gap-x-3" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="700">
                  <span class="flex items-center icon-star text-orange-500"></span>
                  <span class="">Tailored travel policies that optimize cost and
                                            compliance.</span>
                </li>
                <li class="flex gap-x-3" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="800">
                  <span class="flex items-center icon-star text-orange-500"></span>
                  <span class="">Priority access to airport lounges and fast-track
                                            services.</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="flex flex-col items-center justify-center cloud-wrapper">
            <img src="assets/images/airoplane.png" class="static-object desk-img" data-sal="zoom-in"  data-sal-duration ='1000' data-sal-delay="300"
                 alt="Corporate air travel solutions" width="628px" height="352px" loading="lazy" alt="Air Travel">
            <img src="assets/images/airoplane.png" class="static-object mob-img" data-sal="zoom-in"  data-sal-duration ='1000' data-sal-delay="300"
                 alt="Corporate air travel solutions" width="302px" height="168px" loading="lazy" alt="Air Travel">
            <div class="clouds">
              <img src="https://i.postimg.cc/PrMrJc9d/cloud1.png" style="--i:1" alt="cloud">
              <img src="https://i.postimg.cc/fRTW9CQm/cloud2.png" style="--i:2" alt="cloud">
              <img src="https://i.postimg.cc/sg6j9W38/cloud3.png" style="--i:3" alt="cloud">
              <img src="https://i.postimg.cc/LsGmGMY3/cloud4.png" style="--i:4" alt="cloud">
              <img src="https://i.postimg.cc/jjDs8j5j/cloud5.png" style="--i:5" alt="cloud">
              <img src="https://i.postimg.cc/PrMrJc9d/cloud1.png" style="--i:6" alt="cloud">
              <img src="https://i.postimg.cc/fRTW9CQm/cloud2.png" style="--i:7" alt="cloud">
              <img src="https://i.postimg.cc/sg6j9W38/cloud3.png" style="--i:8" alt="cloud">
              <img src="https://i.postimg.cc/LsGmGMY3/cloud4.png" style="--i:9" alt="cloud">
              <img src="https://i.postimg.cc/jjDs8j5j/cloud5.png" style="--i:10" alt="cloud">
            </div>
          </div>

        </div>
        <div id="tabs-with-icons-2" class="hidden" role="tabpanel" aria-labelledby="tabs-with-icons-item-2">
          <div class="grid lg:grid-cols-2 gap-4">
            <div class="p-5">
              <span class="title-tag-line inline-flex" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="500">Comfort and Convenience</span>
              <h2 class="title-second-sub my-3" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="700">The Business Traveler's Accommodation Guide</h2>
              <p class="" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="800">Finding the right accommodation can be challenging for business travelers,
                especially when factoring in budget, location, and amenities</p>
              <ul class="space-y-3 mt-7">
                <li class="flex gap-x-3" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="500">
                  <span class="flex items-center icon-star text-orange-500"></span>
                  <span class="">Negotiated rates with top hotel chains and boutique
                                            options.</span>
                </li>

                <li class="flex gap-x-3" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="700">
                  <span class="flex items-center icon-star text-orange-500"></span>
                  <span class="">Proximity to meeting venues and key business locations.</span>
                </li>
                <li class="flex gap-x-3" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="800">
                  <span class="flex items-center icon-star text-orange-500"></span>
                  <span class="">Loyalty program integration for frequent travelers.</span>
                </li>
              </ul>
            </div>
            <div class="p-5 desk-img">

              <div class="flex flex-col items-center">
                <img src="assets/images/hotel.png" alt="Business Traveler's Accommodation Guide" data-sal="zoom-in"  data-sal-duration ='500' data-sal-delay="500"
                     class="desk-img" width="411px" height="423px" loading="lazy">
              </div>
            </div>
          </div>

        </div>
        <div id="tabs-with-icons-3" class="hidden" role="tabpanel" aria-labelledby="tabs-with-icons-item-3">
          <div class="grid lg:grid-cols-2 gap-4">
            <div class="p-5">
              <span class="title-tag-line inline-flex" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="500">Smooth Transfers</span>
              <h2 class="title-second-sub my-3" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="700">Your Reliable Ground Transportation Partner</h2>
              <p class="" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="800">Umbrella Travel arranges ground transportation that fits your schedule and
                preferences.</p>
              <ul class="space-y-3 mt-7">
                <li class="flex gap-x-3" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="500">
                  <span class="flex items-center icon-star text-orange-500"></span>
                  <span class="">Pre-arranged transfers, so you're never left waiting.</span>
                </li>

                <li class="flex gap-x-3" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="700">
                  <span class="flex items-center icon-star text-orange-500"></span>
                  <span class="">Real-time tracking and support for changes in plans.</span>
                </li>
                <li class="flex gap-x-3" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="800">
                  <span class="flex items-center icon-star text-orange-500"></span>
                  <span class="">Partnerships with trusted car rental and chauffeur
                                            services.</span>
                </li>
              </ul>
            </div>
            <div class="p-5 desk-img">

              <div class="flex flex-col relative justify-center items-center">
                <img src="assets/images/ground-travel.png" alt="Ground Transportation Partner" data-sal="zoom-in"  data-sal-duration ='500' data-sal-delay="500"
                     class="desk-img" width="529px" height="476px" loading="lazy">

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>
<section id="approachSection" class="approach-section ">
  <div class="container mx-auto ps-4 border-l border-l-gray-300   section-bottom-pad">
    <div class="relative  bg-blur">
      <img src="assets/images/our-approach.png" alt="our-approach " class="mx-auto desk-img" loading="lazy" data-sal="zoom-in"  data-sal-duration ='500' data-sal-delay="500"
           width="555px" height="466px">
      <img src="assets/images/our-approach-mobile.png" alt="our-approach " class="mx-auto mob-img" data-sal="zoom-in"  data-sal-duration ='500' data-sal-delay="500"
           loading="lazy" width="301px" height="252px">
      <span class="title-circle blue" data-sal="zoom-out"  data-sal-duration ='1000' data-sal-delay="500">
                    <span class="icon-handshake"></span>
                </span>
    </div>
    <div class="section-top-mar section-top-pad approachsection">
      <div class="approach-left">
        <span class="title-tag-line inline-flex" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="500">Our</span>
        <h2 class="title-sub mt-3" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="700">Approach</h2>
        <p class="font-normal" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="800">Expertly crafted travel solutions, ensuring smooth journeys, cost control,
          and maximum efficiency.</p>
        <a href="" class="butn butn-orange mt-6 " data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="1000">Explore Solutions<span
          class="ms-3 icon-arrow-right-long"></span></a>
      </div>
      <div class="approach-right overflow-hidden">
        <div id="approach-carousel-wrapper">
          <owl-carousel-o id="approchCarousel" [options]="carouselOptions">
            <ng-template carouselSlide *ngFor="let item of carouselItems">
              <div class="item">
                <img [src]="item.image" [alt]="item.title"/>
                <div class="overlay-slider">
                  <span class="text-xl font-medium text-white transition-all">{{ item.title }}</span>
                  <p class="overlay-content">{{ item.content }}</p>
                </div>
              </div>
            </ng-template>
          </owl-carousel-o>
        </div>
      </div>
    </div>
    <div class="section-top-mar section-top-pad optimize-cost-counter">
      <span class="title-tag-line inline-flex" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="500">Optimize</span>
      <h2 class="title-sub mt-3" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="700">Your Corporate Travel <br>Costs with Umbrella Travel</h2>
        <ul id="counter">
        <li data-sal="slide-up"  data-sal-duration ='700' data-sal-delay="800">
                        <span class="count percent" data-count="90">
                            0
                        </span>
          <p class="text-lg font-normal text-black mt-5">Clients satisfied with our services</p>
        </li>
        <li data-sal="slide-up"  data-sal-duration ='700' data-sal-delay="800">
                        <span class="count percent" data-count="30">
                            0
                        </span>
          <p class="text-lg font-normal text-black mt-5">Savings on corporate rates</p>
        </li>
        <li data-sal="slide-up"  data-sal-duration ='700' data-sal-delay="800">
                        <span class="count percent" data-count="20">
                            0
                        </span>
          <p class="text-lg font-normal text-black mt-5">Lower costs with early booking</p>
        </li>
      </ul>
    </div>
  </div>
</section>
<section class="why-us-section relative">
  <div class="container mx-auto ps-4 border-l border-l-gray-300  section-top-pad section-bottom-pad ">
    <div class="grid lg:grid-cols-3 gap-4 section-top-pad section-top-mar">
      <div class="col-span-2">
        <span class="title-tag-line inline-flex " data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="500">Why Choose</span>
        <h2 class="title-sub mt-3" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="700">Umbrella Travel?</h2>

        <ul class="space-y-7 mt-7 text-sm">
          <li class="flex gap-x-3" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="200">
            <img src="assets/images/arrow-icon.png" class="w-[40px] h-[40px] min-h-[40px] min-w-[40px]"
                 alt="">
            <div>
              <h2 class="title-second-sub">Personalized Solutions</h2>
              <p>We create customized travel management strategies that align with your business
                objectives.</p>
            </div>
          </li>

          <li class="flex gap-x-3" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="500">
            <img src="assets/images/arrow-icon.png" class="w-[40px] h-[40px] min-h-[40px] min-w-[40px]"
                 alt="">
            <div>
              <h2 class="title-second-sub">Cost Savings</h2>
              <p>Our negotiation skills and industry partnerships allow us to secure the best deals
                for our clients.</p>
            </div>
          </li>
          <li class="flex gap-x-3" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="700">
            <img src="assets/images/arrow-icon.png" class="w-[40px] h-[40px] min-h-[40px] min-w-[40px]"
                 alt="">
            <div>
              <h2 class="title-second-sub">Expertise Across Industries</h2>
              <p>From corporate travel to government, SMMEs, and the film industry, we are equipped to
                handle a variety of complex travel needs.</p>
            </div>
          </li>
          <li class="flex gap-x-3" data-sal="slide-up"  data-sal-duration ='500' data-sal-delay="1000">
            <img src="assets/images/arrow-icon.png" class="w-[40px] h-[40px] min-h-[40px] min-w-[40px]"
                 alt="">
            <div>
              <h2 class="title-second-sub">Real-Time Insights</h2>
              <p>Access cutting-edge technology that offers real-time updates and reporting for
                complete visibility over your travel management.</p>
            </div>
          </li>
        </ul>
      </div>
      <div>

      </div>
    </div>
  </div>
</section>
